import { Outlet } from 'react-router-dom';
import { Box } from '@mui/joy';

export const HrApp = () => (
  <Box sx={{ p: { xs: 1.5, md: 3 }, width: '100%', minWidth: 0 }}>
    <Outlet />
  </Box>
);

export default HrApp;
